import "ol/ol.css";
import { Map, View } from "ol";
import {
  OSMLayer,
  OSMLayer2,
  tbbDigerYapi,
  tbbIlceler,
  tbbKapi,
  tbbMahalle,
  tbbParsel,
  tbbYapi,
  tbbYol,
} from "../Layers/Basemaps/OSMLayer";
import { MunicipalityNaneFrontSetting } from "../../../config";

const MyMap = new Map({
  target: null,
  layers: [
    OSMLayer,
    OSMLayer2,
    tbbIlceler,
    tbbMahalle,
    tbbYapi,
    tbbDigerYapi,
    tbbYol,
    tbbKapi,
    tbbParsel,
  ],
  controls: [],

  view: new View({
    extent: MunicipalityNaneFrontSetting.border[0].extent,
    center: [0, 0],
    zoom: 1,
    projection: "EPSG:3857",
  }),
});

export default MyMap;
